module.exports = __webpack_public_path__ + "img/fidc-bg-1.a7a453e2.png";